import {
  type IconSet,
  CFARIconNameEnum,
  IconNameEnum,
  defaultCarIcons,
  defaultIcons,
} from "@b2bportal/core-themes";
import {
  ArrowRight,
  Ban,
  BedDouble as Bed,
  BedSingle,
  Bed as BedOther,
  Bath,
  Sparkles,
  Calendar,
  Car,
  CircleAlert,
  CircleHelp,
  CirclePlus,
  CircleX,
  Clock10,
  CookingPot,
  ExternalLink as LucideExternalLink,
  Globe,
  Home,
  Info as InfoOutline,
  IterationCw as Iteration,
  Mail,
  MessageCircle,
  PhoneCall,
  ParkingCircle,
  Pencil,
  Plane,
  RotateCcw,
  Search,
  Shield,
  ShieldCheck,
  ShieldX,
  SlidersHorizontal,
  Sofa,
  TicketX,
  Timer as LucideTimer,
  Trees,
  TrendingDown,
  TrendingUp,
  TriangleAlert,
  Tv,
  CircleChevronLeft,
  CircleDollarSign,
  List,
  AlertCircle,
} from "lucide-react";
import ActivitiesActive from "../assets/icons/activities-active.svg?react";
import Activities from "../assets/icons/activities.svg?react";
import AirplaneArrive from "../assets/icons/airplane-arrive.svg?react";
import AirplaneDeparture from "../assets/icons/airplane-departure.svg?react";
import FlightsTrips from "../assets/icons/airplane.svg?react";
import AvionCoin from "../assets/icons/avion-coin.svg?react";
import CarsTrips from "../assets/icons/car.svg?react";
import CarsActive from "../assets/icons/cars-active.svg?react";
import Cars from "../assets/icons/cars.svg?react";
import ConfirmationIcon from "../assets/icons/confirmation.svg?react";
import CVV from "../assets/icons/cvv.svg?react";
import FlightsActive from "../assets/icons/flights-active.svg?react";
import Flights from "../assets/icons/flights.svg?react";
import HotelBuilding from "../assets/icons/hotel-building.svg?react";
import HotelsTrips from "../assets/icons/hotel.svg?react";
import HtsPoweredByLogo from "../assets/icons/hts-powered-by-logo.svg?react";
import LuggageTrips from "../assets/icons/luggage-trips.svg?react";
import DisruptionBaggageChecked from "../assets/icons/luggage.svg?react";
import DisruptionRebookMoneyConfirmation from "../assets/icons/money-fill.svg?react";
import DisruptionNoFlightsIcon from "../assets/icons/no-flights-icon.svg?react";
import PackagesActive from "../assets/icons/packages-active.svg?react";
import Packages from "../assets/icons/packages.svg?react";
import DisruptionReturnFlight from "../assets/icons/return-flight-airplane.svg?react";
import StaysActiveWithBackground from "../assets/icons/stays-active-with-background.svg?react";
import StaysActive from "../assets/icons/stays-active.svg?react";
import Stays from "../assets/icons/stays.svg?react";

// RBC design system icons (UI)
import Accessibility from "../assets/icons/ui/accessibility.svg?react";
import Add from "../assets/icons/ui/add.svg?react";
import ArrowRightAlt from "../assets/icons/ui/arrow-right-alt.svg?react";
import Binoculars from "../assets/icons/ui/binoculars.svg?react";
import CfarCheckout from "../assets/icons/ui/cfar-checkout.svg?react";
import CfarProduct from "../assets/icons/ui/cfar-product.svg?react";
import CfarShield from "../assets/icons/ui/cfar-shield.svg?react";
import CheckBubble from "../assets/icons/ui/check-bubble.svg?react";
import CheckFilled from "../assets/icons/ui/check-filled.svg?react";
import CheckmarkBullet from "../assets/icons/ui/checkmark-bullet.svg?react";
import Checkmark from "../assets/icons/ui/checkmark.svg?react";
import ChevronDown from "../assets/icons/ui/chevron-down.svg?react";
import ChevronLeft from "../assets/icons/ui/chevron-left.svg?react";
import ChevronRight from "../assets/icons/ui/chevron-right.svg?react";
import Close from "../assets/icons/ui/close.svg?react";
import Collapse from "../assets/icons/ui/collapse.svg?react";
import Coverage from "../assets/icons/ui/coverage.svg?react";
import CreditCard from "../assets/icons/ui/credit-card.svg?react";
import Declined from "../assets/icons/ui/declined.svg?react"; // PDA "No thanks" (15×15)
import DisruptionAssistance from "../assets/icons/ui/disruption-assistance.svg?react";
import DropOff from "../assets/icons/ui/drop-off.svg?react";
import Exchange from "../assets/icons/ui/exchange.svg?react";
import Expand from "../assets/icons/ui/expand.svg?react";
import FintechCheckmark from "../assets/icons/ui/fintech-checkmark.svg?react";
import FreeCancellation from "../assets/icons/ui/free-cancellation.svg?react";
import Help from "../assets/icons/ui/help.svg?react";
import InfoFilledBlue from "../assets/icons/ui/info-filled-blue.svg?react";
import Info from "../assets/icons/ui/info.svg?react";
import Left from "../assets/icons/ui/left.svg?react";
import Location from "../assets/icons/ui/location.svg?react";
import MapPinFill from "../assets/icons/ui/map-pin-fill.svg?react";
import MinusOutline from "../assets/icons/ui/minus-outline.svg?react";
import NumberOfPassengers from "../assets/icons/ui/number-of-passengers.svg?react";
import OffersPercent from "../assets/icons/ui/offers-percent.svg?react";
import Offers from "../assets/icons/ui/offers.svg?react";
import PickUp from "../assets/icons/ui/pick-up.svg?react";
import PlusOutline from "../assets/icons/ui/plus-outline.svg?react";
import PointsCreditCard from "../assets/icons/ui/points-credit-card.svg?react";
import PointsShoppingCart from "../assets/icons/ui/points-shopping-cart.svg?react";
import PointsStar from "../assets/icons/ui/points-star.svg?react";
import PriceTag from "../assets/icons/ui/price-tag.svg?react";
import Rating from "../assets/icons/ui/rating.svg?react";
import RecentlySearched from "../assets/icons/ui/recently-searched.svg?react";
import Remove from "../assets/icons/ui/remove.svg?react";
import Right from "../assets/icons/ui/right.svg?react";
import SeatBasic from "../assets/icons/ui/seat-basic.svg?react";
import SeatEnhanced from "../assets/icons/ui/seat-enhanced.svg?react";
import SeatLuxury from "../assets/icons/ui/seat-luxury.svg?react";
import SeatPremium from "../assets/icons/ui/seat-premium.svg?react";
import SeatStandard from "../assets/icons/ui/seat-standard.svg?react";
import Seat from "../assets/icons/ui/seat.svg?react";
import SmokingArea from "../assets/icons/ui/smoking-area.svg?react";
import Swap from "../assets/icons/ui/swap.svg?react";
import TimesAlt from "../assets/icons/ui/times-alt.svg?react";
import Travel from "../assets/icons/ui/travel.svg?react";
import Users from "../assets/icons/ui/users.svg?react";
import Wallet from "../assets/icons/ui/wallet.svg?react";
import Warning from "../assets/icons/ui/warning.svg?react"; // Figma Export
import WatchActive from "../assets/icons/ui/watch-active.svg?react";
import WesternStyle from "../assets/icons/ui/western-style.svg?react";

import { hotelAmenitiesIcon } from "./hotelAmenities";
import { TenantIconNameEnum } from "@/types/tenantIcons";

/*
 * NEED TO ADD TENANT SPECIFIC ICONS?
 * Add enum to `app/src/theme/types` then add icon here.
 */

const carIcons = {
  ...defaultCarIcons,
  [IconNameEnum.car__rentalAttribute]: TicketX,
  [IconNameEnum.car__passenger]: Coverage,
  [IconNameEnum.car__bags]: Coverage,
  [IconNameEnum.car__transmission]: Coverage,
  [IconNameEnum.car__airConditioning]: Coverage,
  [IconNameEnum.car__mileage]: Coverage,
};

const hotelIcons = {
  [IconNameEnum.stays__tv]: Tv,
  [IconNameEnum.stays__cookingPot]: CookingPot,
  [IconNameEnum.stays__trees]: Trees,
  [IconNameEnum.stays__bathroom]: Bath,
  [IconNameEnum.stays__bedSingle]: BedSingle,
  [IconNameEnum.stays__bedOther]: BedOther,
  [IconNameEnum.stays__sofa]: Sofa,
  [IconNameEnum.stays__parking]: ParkingCircle,
  [IconNameEnum.stays__security]: ShieldCheck,
  [IconNameEnum.stays__cleaning]: Sparkles,
};

const tripsIcons = {
  [IconNameEnum.flightsTrips]: FlightsTrips,
  [IconNameEnum.hotelsTrips]: HotelsTrips,
  [IconNameEnum.carsTrips]: CarsTrips,
  [IconNameEnum.luggageTrips]: LuggageTrips,
};

export const lightModeIcons: IconSet = {
  ...carIcons,
  ...hotelIcons,
  ...tripsIcons,

  // RBC design system icons
  [TenantIconNameEnum.accessibility]: Accessibility,
  [TenantIconNameEnum.binoculars]: Binoculars,
  [TenantIconNameEnum.home]: Home,
  [TenantIconNameEnum.hotelBuilding]: HotelBuilding,
  [TenantIconNameEnum.circleChevronLeft]: CircleChevronLeft,
  [IconNameEnum.close]: Close,
  [IconNameEnum.backIcon]: Left,
  [IconNameEnum.leftNavChevron]: ChevronLeft,
  [IconNameEnum.actionIcon]: Right,
  [IconNameEnum.nextIcon]: ChevronRight,
  [IconNameEnum.rightNavChevron]: ChevronRight,
  [IconNameEnum.dropdownArrow]: Expand,
  [IconNameEnum.chevronDown]: Expand,
  [IconNameEnum.chevronUp]: Collapse,
  [TenantIconNameEnum.chevron]: Collapse,
  [IconNameEnum.plus]: Add,
  [IconNameEnum.minus]: Remove,
  [IconNameEnum.mapPin]: Location,
  [IconNameEnum.info]: Info,
  [IconNameEnum.check]: Checkmark,
  [IconNameEnum.checkFilled]: CheckFilled,
  [IconNameEnum.fareDetailsAvailable]: CheckFilled,
  [IconNameEnum.confirmation]: ConfirmationIcon,
  [IconNameEnum.checkBulletPoint]: CheckmarkBullet,
  [IconNameEnum.disruptionFintechCheckmarkBulletPoint]: FintechCheckmark,
  [IconNameEnum.fareClassBasic]: SeatBasic,
  [IconNameEnum.fareClassStandard]: SeatStandard,
  [IconNameEnum.fareClassEnhanced]: SeatEnhanced,
  [IconNameEnum.fareClassPremium]: SeatPremium,
  [IconNameEnum.fareClassLuxury]: SeatLuxury,
  [IconNameEnum.disruptionProtection]: Coverage,
  [IconNameEnum.passengerSelection]: NumberOfPassengers,
  [IconNameEnum.avionCoin]: AvionCoin,
  [TenantIconNameEnum.checkBubble]: CheckBubble,
  [TenantIconNameEnum.offersPercent]: OffersPercent,
  [TenantIconNameEnum.priceTag]: PriceTag,
  [TenantIconNameEnum.arrowRightAlt]: ArrowRightAlt,
  [TenantIconNameEnum.wallet]: Wallet,
  [TenantIconNameEnum.mapPinFill]: MapPinFill,
  [TenantIconNameEnum.plusOutline]: PlusOutline,
  [TenantIconNameEnum.minusOutline]: MinusOutline,
  [TenantIconNameEnum.help]: Help,
  [TenantIconNameEnum.timesAlt]: TimesAlt,
  [IconNameEnum.guest]: NumberOfPassengers,
  [IconNameEnum.users]: Users,
  [IconNameEnum.travel]: Travel,
  [IconNameEnum.rating]: Rating,
  [IconNameEnum.offers]: Offers,
  [IconNameEnum.recentlySearched]: RecentlySearched,
  [IconNameEnum.disruptionAssistance]: DisruptionAssistance,
  [IconNameEnum.freeCancellation]: FreeCancellation,
  [IconNameEnum.dropOff]: DropOff,
  [IconNameEnum.pickUp]: PickUp,
  [IconNameEnum.smokingArea]: SmokingArea,
  [IconNameEnum.watchActive]: WatchActive,
  [IconNameEnum.westernStyle]: WesternStyle,
  [IconNameEnum.seat]: Seat,
  [IconNameEnum.flights]: Flights,
  [IconNameEnum.flights__active]: FlightsActive,
  [IconNameEnum.car]: Car,
  [IconNameEnum.cars__active]: CarsActive,
  [IconNameEnum.stays]: Stays,
  [IconNameEnum.stays__active]: StaysActive,
  [IconNameEnum.stays__active__with_background]: StaysActiveWithBackground,
  [IconNameEnum.activities]: Activities,
  [IconNameEnum.activities__active]: ActivitiesActive,
  [IconNameEnum.packages]: Packages,
  [IconNameEnum.packages__active]: PackagesActive,
  // Lucide icons
  [IconNameEnum.airplane]: Plane,
  // RBC-specific takeoff/landing glyphs from the Figma designs; core's
  // defaults sit slightly off the RBC spec.
  [IconNameEnum.airplaneDeparture]: AirplaneDeparture,
  [IconNameEnum.airplaneArrive]: AirplaneArrive,
  [IconNameEnum.calendar]: Calendar,
  [IconNameEnum.calendarSeparatorIcon]: ArrowRight,
  [IconNameEnum.edit]: Pencil,
  [IconNameEnum.email]: Mail,
  [IconNameEnum.externalLink]: LucideExternalLink,
  [IconNameEnum.clock]: Clock10,
  [IconNameEnum.world]: Globe,
  [IconNameEnum.search]: Search,
  [IconNameEnum.filter]: SlidersHorizontal,
  [IconNameEnum.error]: CircleAlert,
  [IconNameEnum.timer]: LucideTimer,
  [IconNameEnum.dropdownTriangle]: ChevronDown,
  [IconNameEnum.resetFilter]: RotateCcw,
  [IconNameEnum.fareDetailsUnavailable]: Ban,
  [IconNameEnum.fareDetailsCharge]: CircleDollarSign,
  [IconNameEnum.fareDetailsGeneric]: List,
  [IconNameEnum.cvv]: CVV,
  [IconNameEnum.cfar__notAllowed]: Ban,
  [IconNameEnum.cfar__info]: InfoFilledBlue,
  [IconNameEnum.cfar__checkout]: CfarCheckout,
  [IconNameEnum.cfar__shieldInfo]: ShieldX,
  [IconNameEnum.disruptionHowItWorksDialogInfoLineOne]: TriangleAlert,
  [IconNameEnum.disruptionHowItWorksDialogInfoLineTwo]: Plane,
  [IconNameEnum.disruptionHowItWorksDialogInfoLineThree]: ShieldX,
  [IconNameEnum.cancelCircle]: CircleX,
  [IconNameEnum.questionCircle]: CircleHelp,
  [IconNameEnum.exchange]: Exchange,
  [TenantIconNameEnum.swap]: Swap,
  [IconNameEnum.base__genericError]: CircleX,
  [IconNameEnum.infoOutline]: InfoOutline,
  [IconNameEnum.ticket]: TicketX,
  [IconNameEnum.plusCircle]: CirclePlus,
  [IconNameEnum.iteration]: Iteration,
  [IconNameEnum.disruptionExerciseFullyCoveredIcon]:
    DisruptionRebookMoneyConfirmation,
  [IconNameEnum.baggageChecked]: DisruptionBaggageChecked,
  [IconNameEnum.disruptionNoFlightsIcon]: DisruptionNoFlightsIcon,
  [IconNameEnum.flightOutline]: DisruptionReturnFlight,
  [IconNameEnum.htsPoweredByLogo]: HtsPoweredByLogo,
  [IconNameEnum.pricePrediction]: TrendingUp,
  [IconNameEnum.predictionNormal]: TrendingUp,
  [IconNameEnum.predictionWarning]: TrendingUp,
  [IconNameEnum.predictionDanger]: TrendingDown,
  [IconNameEnum.alertOutline]: TriangleAlert,
  [IconNameEnum.bed]: Bed,
  [IconNameEnum.cars]: Cars,
  [IconNameEnum.cancelForAnyReason]: CfarShield,
  [IconNameEnum.cfarLogo]: CfarProduct,
  [IconNameEnum.customerSupport]: MessageCircle,
  [IconNameEnum.phone]: PhoneCall,
  [IconNameEnum.disruptionConfirmationIcon]: ConfirmationIcon,
  [IconNameEnum.premiumDisruptionAssistance]: Shield,
  [IconNameEnum.disruptionDeclined]: Declined,
  [IconNameEnum.warning]: Warning,
  [IconNameEnum.warningCircle]: AlertCircle,
  [TenantIconNameEnum.pointsCreditCard]: PointsCreditCard,
  [CFARIconNameEnum.creditCard]: CreditCard,
  [TenantIconNameEnum.pointsShoppingCart]: PointsShoppingCart,
  [TenantIconNameEnum.pointsStar]: PointsStar,
  [IconNameEnum.ui__accordionAction]: ChevronDown,
  [IconNameEnum.ui__infoPopover]: InfoFilledBlue,
};

export const darkModeIcons: IconSet = {
  ...defaultIcons,
  ...defaultCarIcons,
  ...lightModeIcons,
  ...tripsIcons,
};

export const icons: IconSet = {
  ...defaultIcons,
  ...lightModeIcons,
  hotelAmenities: hotelAmenitiesIcon,
};

export default icons;
